import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { closeSearchChurchModal } from 'features/memberships/membershipSlice'
import { TbBuildingChurch } from 'react-icons/tb'
import { HiOutlineUsers } from 'react-icons/hi'

export default function ChurchSearchResultsItem({ data }) {
    const navigate     = useNavigate()
    const dispatch     = useDispatch()
    const [hovered, setHovered]         = useState(false)
    const [memberCount, setMemberCount] = useState(null)

    useEffect(() => {
        try {
            const count = Object.keys(data.members).length
            setMemberCount(count)
        } catch {
            setMemberCount(null)
        }
    }, [data.members])

    const handleGoTo = () => {
        dispatch(closeSearchChurchModal())
        navigate(`/${data.username}`)
    }

    const avatarUrl = data.profileImg?.url

    return (
        <Row
            onClick={handleGoTo}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            hovered={hovered}
        >
            {/* Avatar */}
            <Avatar>
                {avatarUrl ? (
                    <img src={avatarUrl} alt={data.fullName} />
                ) : (
                    <AvatarFallback>
                        <TbBuildingChurch />
                    </AvatarFallback>
                )}
            </Avatar>

            {/* Info */}
            <Info>
                <ChurchName>{data.fullName}</ChurchName>
                <MetaRow>
                    {memberCount !== null && (
                        <MetaChip>
                            <HiOutlineUsers />
                            <span>{memberCount} member{memberCount !== 1 ? 's' : ''}</span>
                        </MetaChip>
                    )}
                    {data.denomination && (
                        <MetaChip>
                            <span>{data.denomination}</span>
                        </MetaChip>
                    )}
                </MetaRow>
            </Info>

            {/* View button */}
            <ViewBtn hovered={hovered}>
                View
            </ViewBtn>
        </Row>
    )
}

/* ── Styles ─────────────────────────────────────────────────────────────────── */

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 10px 10px;
    border-radius: 12px;
    cursor: pointer;
    background-color: ${p => p.hovered ? '#f5f5f5' : 'transparent'};
    transition: background-color 0.12s;
    border: 1px solid ${p => p.hovered ? '#e8e8e8' : 'transparent'};
`

const Avatar = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f0f0f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`

const AvatarFallback = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
    font-size: 22px;
`

const Info = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
`

const ChurchName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #222;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const MetaRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
`

const MetaChip = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #888;
    background: #f0f0f0;
    padding: 2px 8px;
    border-radius: 20px;
`

const ViewBtn = styled.button`
    flex-shrink: 0;
    padding: 7px 18px;
    border-radius: 20px;
    border: 1.5px solid ${p => p.hovered ? 'var(--themeColor)' : '#ddd'};
    background: ${p => p.hovered ? 'var(--themeColor)' : 'transparent'};
    color: ${p => p.hovered ? '#fff' : '#aaa'};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
`
